import { render, staticRenderFns } from "./ShowSemiFullscreenButton.vue?vue&type=template&id=0772bb04&"
import script from "./ShowSemiFullscreenButton.vue?vue&type=script&lang=js&"
export * from "./ShowSemiFullscreenButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports